import { GenericRule } from '../../../../../../../utils/genericValidator.util';
import { OfflineOrderProduct } from '../../OfflineOrderProduct';

export class ValidateGridLength implements GenericRule<OfflineOrderProduct> {
  validateOrThrow(orderProduct: OfflineOrderProduct) {
    if (!orderProduct.grid.length) {
      throw new Error('grid is required');
    }
  }
}
